import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, AlertCircle } from 'lucide-react';
import { Button } from '../common/Button';

interface SupplierRequestSuccessProps {
  onClose: () => void;
}

export const SupplierRequestSuccess: React.FC<SupplierRequestSuccessProps> = ({ onClose }) => {

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white rounded-lg shadow-xl max-w-md w-full"
      >
        <div className="p-6">
          <div className="text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="w-8 h-8 text-green-600" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Request Submitted Successfully!</h3>
            <p className="text-gray-600 mb-6">
              Your supplier account request has been submitted and is pending admin approval.
            </p>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <div className="flex items-start">
              <AlertCircle className="h-5 w-5 text-blue-600 mr-2 mt-0.5 flex-shrink-0" />
              <div>
                <h4 className="text-sm font-medium text-blue-800">📧 Email Notification</h4>
                <p className="text-sm text-blue-700 mt-1">
                  Please monitor your email for approval notification. The email will come from <strong>solarpanelmatcher@gmail.com</strong>. 
                  Once approved, you can log in and set your own secure password.
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-3 text-sm text-gray-600">
            <p>
              <strong>Next Steps:</strong>
            </p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Check your email regularly for approval notification</li>
              <li>Look for emails from <strong>solarpanelmatcher@gmail.com</strong></li>
              <li>Once approved, log in and create your secure password</li>
              <li>Complete your supplier profile and start receiving leads</li>
              <li>If you don't receive approval within 48 hours, contact <strong>marketing@energysolutions-solar.com</strong></li>
            </ul>
          </div>

          <div className="flex justify-center mt-6">
            <Button onClick={onClose} className="px-6">
              Close
            </Button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};
